// autopilot-stateless-subcommands-registration.ts
//
// Gom các lệnh `autopilot` KHÔNG đọc state mission (không lock, không config):
// F2 `schema <name>` (zod) + V2 §7 `capabilities --json` (probe của pack).
// Tách khỏi autopilot.ts (review phase 02 L7: file chạm trần 200 dòng). Thứ tự
// đăng ký giữ nguyên ⇒ help + registry lệnh không đổi.
import type { Command } from "commander";
import { registerAutopilotCapabilitiesCommand } from "./autopilot-capabilities-command.js";
import { registerAutopilotSchemaCommand } from "./autopilot-schema-command.js";

export function registerAutopilotStatelessSubcommands(autopilot: Command): void {
  registerAutopilotSchemaCommand(autopilot);
  registerAutopilotCapabilitiesCommand(autopilot);
}
